import React from 'react'
import { connect } from 'react-redux'
import { reportError } from '@app/store/slices/error-slice'

interface ErrorBoundaryProps {
  children: React.ReactNode
  fallback?: (resetError: () => void) => React.ReactNode
  section?: string
  reportError: typeof reportError
}

interface ErrorBoundaryState {
  hasError: boolean
}

class ErrorBoundary extends React.Component<ErrorBoundaryProps, ErrorBoundaryState> {
  constructor(props: ErrorBoundaryProps) {
    super(props)
    this.state = { hasError: false }
  }

  static getDerivedStateFromError(_: Error): ErrorBoundaryState {
    return { hasError: true }
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    const { section } = this.props
    if (section) {
      this.props.reportError({
        partKey: section,
        message: error.message,
        error: true,
      })
    } else {
      console.warn(`Section not specified.`)
    }

    const sectionInfo = section ? ` in section ${section}` : ''
    console.error(`Error caught${sectionInfo}: `, error, errorInfo)
  }

  resetError = () => {
    this.setState({ hasError: false })
  }

  render() {
    if (this.state.hasError) {
      return this.props.fallback?.(this.resetError) ?? null
    }
    return this.props.children
  }
}

const mapDispatchToProps = {
  reportError,
}

export default connect(null, mapDispatchToProps)(ErrorBoundary)
